// PFA card swatches — save as assets/pfa-card-swatches.js
// Hover (desktop) or tap a swatch to swap the card image and point the card link at that colour.
(function () {
  function pick(btn) {
    var card = btn.closest('.card-wrapper');
    if (!card) return;

    var img = card.querySelector('.card__media img');
    if (img && btn.dataset.src) {
      if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
      img.src = btn.dataset.src;
      card.classList.add('pfa-swatched');
    }

    if (btn.dataset.url) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.href = btn.dataset.url;
      });
    }

    card.querySelectorAll('.pfa-swatch').forEach(function (s) {
      s.classList.toggle('is-active', s === btn);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pfa-swatch');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    pick(btn);
  });

  document.addEventListener('mouseover', function (e) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var btn = e.target.closest('.pfa-swatch');
    if (btn) pick(btn);
  });
})();
